module.exports = __webpack_public_path__ + "static/media/SK5.4ea1344d.jpg";